export default __webpack_public_path__ + "static/media/difficulty.8dd5a476.svg";